'use strict';

module.exports = require('./ReactAI').ReactAI;
module.exports.TrackedComponent = require('./components/TrackedComponent').TrackedComponent;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-appinsights/lib/index.js
 ** module id = 538
 ** module chunks = 0
 **/